/* eslint-disable react-hooks/exhaustive-deps */
import jwtDecode from 'jwt-decode';
import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client';
import { TwoFactorAuthType } from '@libs/types';
import { getCurrentDate, getDate, getDateDifference } from './helpers';
export const useAuth = (onLogout, onLogin, tokenKey = 'token') => {
    const client = useApolloClient();
    const logout = useCallback(() => {
        localStorage.removeItem(tokenKey);
        client.clearStore();
        onLogout?.();
    }, [onLogout]);
    const login = useCallback((token) => {
        localStorage.setItem(tokenKey, token);
        onLogin?.();
    }, [onLogin]);
    const decodeToken = useCallback((token = localStorage.getItem(tokenKey)) => {
        try {
            return jwtDecode(token || '');
        }
        catch (error) {
            return null;
        }
    }, []);
    const checkTwoFaValidity = useCallback((userToken, faType) => {
        if (faType === TwoFactorAuthType.SMS &&
            (userToken.isTwoFactorEnabled || userToken.isEmailTwoFactorEnabled)) {
            return false;
        }
        if (faType === TwoFactorAuthType.EMAIL && userToken.isTwoFactorEnabled) {
            return false;
        }
        if (userToken.isEmailTwoFactorEnabled &&
            !userToken.isEmailSecondFactorAuthenticated) {
            return false;
        }
        if (userToken.isSmsTwoFactorEnabled &&
            !userToken.isSmsSecondFactorAuthenticated) {
            return false;
        }
        if (userToken.isTwoFactorEnabled &&
            !userToken.isSecondFactorAuthenticated) {
            return false;
        }
        return true;
    }, []);
    const checkTokenValidity = useCallback((token = localStorage.getItem(tokenKey), faType, shouldValidateTwoFa = true) => {
        const decodedToken = decodeToken(token);
        if (!token ||
            !decodedToken ||
            (shouldValidateTwoFa && !checkTwoFaValidity(decodedToken, faType)))
            return false;
        const now = getCurrentDate();
        const expirationDate = getDate(decodedToken.exp * 1000);
        const dateDiff = getDateDifference(expirationDate, now);
        return dateDiff > 0;
    }, [decodeToken, checkTwoFaValidity]);
    return {
        login,
        logout,
        decodeToken,
        checkTokenValidity,
        tokenKey,
    };
};
//# sourceMappingURL=useAuth.js.map